export function shouldPollPromotionPendingCount({
  isAdmin,
  // pathname is kept on the signature so callers don't have to
  // change, but it no longer gates the badge. The original gating
  // was added to avoid 403 spam on the teacher workbench (non-
  // admin role), but admins on any page should see the live count
  // so they don't miss new pending requests until they happen to
  // open /admin/promotions. The isAdmin gate is the load-bearing
  // one — non-admins still get false and skip the call.
  pathname: _pathname,
}: {
  isAdmin: boolean;
  pathname: string;
}): boolean {
  return isAdmin;
}
